export default __webpack_public_path__ + "static/media/langer_bus_cockpit_weiß.e36ecd30.jpg";